namespace Matrix.Workflow {
    export interface ClientFunctionTriggerParameter {
        Name?: string;
        Title?: string;
        Type?: Data.DataType;
        Visible?: boolean;
        Required?: boolean;
        Size?: number;
        Scale?: number;
        DefaultValue?: string;
        EditorType?: string;
        EditorParams?: { [key: string]: any };
    }
}
